import React, { useContext, useState, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import styles from './sidebar.module.scss'
import eventBus from '@utils/eventBus';

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isPersonalCenter, setPersonalCenter] = useState(false)
    useEffect(() => {
        if (location.pathname == '/home/homemain/personalCenter') {
            setPersonalCenter(true)
        } else {
            setPersonalCenter(false)
        }
    }, [location.pathname]);

    const navigateChange = (value) => {
        if (location.pathname == "/home/homemain/requirement" && value == 3) return
        if (location.pathname == "/home/homemain/requirement") {
            eventBus.emit('requirementForm:edited', () => {
                if(value == 0) {
                    navigate("/home/homemain/dashboard")
                } else if(value == 1) {
                    navigate("/home/homemain/masterDeliver")
                } else if(value == 2) {
                    navigate("/home/homemain/masterShoot")
                } else if(value == 3) {
                    navigate("/home/homemain/requirement")
                }
            })
            return
        }
        if(value == 0) {
            navigate("/home/homemain/dashboard")
        } else if(value == 1) {
            navigate("/home/homemain/masterDeliver")
        } else if(value == 2) {
            navigate("/home/homemain/masterShoot")
        } else if(value == 3) {
            navigate("/home/homemain/requirement")
        }
    }

    const sidebarKey = useMemo(() => {
        if (location.pathname == '/home/homemain/dashboard') {
            return 0
        } else if (location.pathname == '/home/homemain/masterDeliver') {
            return 1
        } else if (location.pathname == '/home/homemain/masterShoot') {
            return 2
        } else if (location.pathname == '/home/homemain/requirement') {
            return 3
        }
    }, [location.pathname])

    return (
        <div className={styles.Sidebar}>
            <div className={styles.Sidebar_top}>
            {
                !isPersonalCenter ?
                <>
                <div className={`${styles.Sidebar_item} ${sidebarKey == 0 ? styles.actived : ""}`} onClick={() => navigateChange(0)}>
                    <img className={styles.sidebar_icon} src={sidebarKey == 0 ? require('@assets/images/delivery/icon_dashboard_actived.png') : require('@assets/images/delivery/icon_dashboard.png')} alt=""/>
                    <p>看板</p>
                </div>
                <div className={`${styles.Sidebar_item} ${sidebarKey == 1 ? styles.actived : ""}`} onClick={() => navigateChange(1)}>
                    <img className={styles.sidebar_icon} src={sidebarKey == 1 ? require('@assets/images/delivery/icon_delivery_actived.png') : require('@assets/images/delivery/icon_delivery.png')} alt=""/>
                    <p>交付结果</p>
                </div>
                <div className={`${styles.Sidebar_item} ${sidebarKey == 2 ? styles.actived : ""}`} onClick={() => navigateChange(2)}>
                    <img className={styles.sidebar_icon} src={sidebarKey == 2 ? require('@assets/images/delivery/icon_selection_actived.png') : require('@assets/images/delivery/icon_selection.png')} alt=""/>
                    <p>初步选图</p>
                </div>
                <div className={`${styles.Sidebar_item} ${sidebarKey == 3 ? styles.actived : ""}`} onClick={() => navigateChange(3)}>
                    <img className={styles.sidebar_icon} src={sidebarKey == 3 ? require('@assets/images/delivery/icon_edit_actived.png') : require('@assets/images/delivery/icon_edit.png')} alt=""/>
                    <p>提需求</p>
                </div>
                </> :
                null
            }
            </div>
        </div>
    );
};

export default Sidebar;